import gql from 'graphql-tag';

export const GET_SIGN_STATE = gql`
query($id: String!) {
  device(id: $id) {
    ... on Sign {
      sign_state {
        program
        program_state
        error_state
        timestamp
      }
      sign_command {
        program
        program_state
        timestamp
      }
      blinking_lights {
        blinking_lights_state {
          program
          program_state
          error_state
          timestamp
        }
        blinking_lights_command {
          program
          program_state
          timestamp
        }
      }
      ambient_brightness {
        brightness
        timestamp
      }
      door_contact_state {
        open
        timestamp
      }
      cluster {
        cluster_state {
          operating_mode
          brightness
          state
          timestamp
        }
        cluster_command {
          operating_mode
          brightness
          timestamp
        }
      }
    }
  }
}
`;

export const GET_SIGN_IMAGE_CONTENT = gql`
query($id: String!, $name: String!) {
  signImageContent(id: $id, name: $name) {
    width
    height
    file_format
    data 
  }
}
`;

export const GET_CB_RADIO_TEXT = gql`
query($id: String!, $name: String!) {
  citizensBandRadioText(id: $id, name: $name)
}
`;

export const GET_CB_RADIO_STATE = gql`
query($id: String!, $name: String!){
  citizensBandRadioState(id: $id, name: $name)
}
`;

export const GET_SENSOR_STATE = gql`
query($id: String!) {
  device(id: $id) {
    ... on TrafficSensor {
      sensor_state {
        error_state
        timestamp
      }
      traffic_data {
        qKfzG
        qLkwG
        qPkwG
        vKfzG
        vLkwG
        vPkwG
        intervalLength
        timestamp
      }
      traffic_situation {
        trafficSituation
        timestamp
      }
    }
  }
}
`;